import { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import SidebarLayout from "./components/layouts/SidebarLayout";
import OpenIssuesHome from "./components/maintenance/OpenIssuesHome";
import OpenIncidentsHome from "./components/monitoring/OpenIncidentsHome";
import DegradedMonitorsHome from "./components/monitoring/DegradedMonitorsHome";
import CleanersPage from "./components/cleaners/CleanersPage";
import EngineerVisitsPage from "./components/engineers/EngineerVisitsPage";
import Login from "./components/Login";
import { AuthProvider } from "./context/AuthContext";
import { UserContext } from "./context/UserContext";
import NotFound from "./components/NotFound";
import Setting from "./components/setting/Setting";
import CustomerServiceSales from "./components/customerservice/CustomerServiceSales";
import HelpdeskPage from "./components/helpdesk/HelpdeskPage";
import MachinesPage from "./components/maintenance/MachineStatus";
import OpsHome from "./components/ops/OpsHome";
import ProxyHealth from "./components/ops/ProxyHealth";
import ProxyCommandHistory from "./components/ops/ProxyCommandHistory";
import KioskFleet from "./components/ops/KioskFleet";
import ReportsOverview from "./components/reports/ReportsOverview";
import SalesByStoreReport from "./components/reports/SalesByStoreReport";
import MachinesLeftCompleteReport from "./components/reports/MachinesLeftCompleteReport";
import ErrorsReport from "./components/reports/ErrorsReport";
import DowntimeReport from "./components/reports/DowntimeReport";

const emptyUser = {
  roleId: 0,
  roleName: "",
  userId: "",
  userName: "",
};

function readStoredUser() {
  try {
    const userStr = localStorage.getItem("userDetails");
    if (!userStr) return emptyUser;
    return JSON.parse(userStr) ?? emptyUser;
  } catch {
    return emptyUser;
  }
}

function App() {
  const [loggedIn, setLoggedIn] = useState(
    () => !!localStorage.getItem("userDetails")
  );
  const [token, setToken] = useState(
    () => localStorage.getItem("authToken") ?? ""
  );
  const [user, setUser] = useState(readStoredUser);

  const PrivateRoute = () => {
    let userStr = localStorage.getItem("userDetails");
    if (userStr) {
      return <Outlet />;
    } else {
      return <Navigate to="/login" replace />;
    }
  };

  return (
    <Router>
      <UserContext.Provider value={{ user }}>
        <AuthProvider>
          <Routes>
            <Route
              path="/login"
              element={
                <Login
                  setLoggedIn={setLoggedIn}
                  setUser={setUser}
                  setToken={setToken}
                />
              }
            />
            {loggedIn ? (
              <Route
                path="/*"
                element={
                  <SidebarLayout setLoggedIn={setLoggedIn}>
                    <Routes>
                      <Route element={<PrivateRoute />}>
                        <Route path="/" element={<Navigate to="/home" replace />} />
                        <Route path="/home" element={<OpsHome />} />
                        <Route path="/kiosks" element={<KioskFleet />} />
                        <Route path="/proxy-health" element={<ProxyHealth />} />
                        <Route
                          path="/proxy-health/commands"
                          element={<ProxyCommandHistory />}
                        />
                        <Route
                          path="/maintenance"
                          element={<Navigate to="/maintenance/open-issues" replace />}
                        />
                        <Route
                          path="/customer-service"
                          element={<Navigate to="/customer-service/sales" replace />}
                        />
                        <Route
                          path="/customer-service/sales"
                          element={<CustomerServiceSales />}
                        />
                        <Route
                          path="/customer-service/helpdesk"
                          element={<HelpdeskPage />}
                        />
                        <Route path="/status" element={<MachinesPage />} />
                        <Route
                          path="/maintenance/open-issues"
                          element={<OpenIssuesHome />}
                        />
                        <Route
                          path="/monitoring"
                          element={<Navigate to="/monitoring/open-incidents" replace />}
                        />
                        <Route
                          path="/monitoring/open-incidents"
                          element={<OpenIncidentsHome />}
                        />
                        <Route
                          path="/monitoring/degraded-monitors"
                          element={<DegradedMonitorsHome />}
                        />
                        <Route
                          path="/maintenance/cleaners"
                          element={<CleanersPage />}
                        />
                        <Route
                          path="/maintenance/engineers"
                          element={<EngineerVisitsPage />}
                        />
                        <Route
                          path="/cleaners"
                          element={<Navigate to="/maintenance/cleaners" replace />}
                        />
                        <Route
                          path="/reports"
                          element={<Navigate to="/reports/overview" replace />}
                        />
                        <Route path="/reports/overview" element={<ReportsOverview />} />
                        <Route
                          path="/reports/sales-by-store"
                          element={<SalesByStoreReport />}
                        />
                        <Route
                          path="/reports/machines-left-complete"
                          element={<MachinesLeftCompleteReport />}
                        />
                        <Route path="/reports/errors" element={<ErrorsReport />} />
                        <Route path="/reports/downtime" element={<DowntimeReport />} />
                        <Route path="/setting" element={<Setting />} />
                      </Route>
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </SidebarLayout>
                }
              />
            ) : (
              <Route path="/*" element={<Navigate to="/login" replace />} />
            )}
          </Routes>
        </AuthProvider>
      </UserContext.Provider>
    </Router>
  );
}

export default App;
